import InboomaBaseAsyncCollection from './InboomaBaseAsyncCollection';
import Appointment from '../models/Appointment';

export default InboomaBaseAsyncCollection.extend({
  
  collectionName : 'appointments',
  model : Appointment,
  url : '/appointments',
  _skipPagination: true,

});